<div class="dialog edit-transit-time-config">
  <h2 mat-dialog-title>Edit Transit Time Configuration</h2>
  <div class="inner">
    <button aria-label="Close" class="dialog__close-btn close-button" (click)="cancel()" [disabled]="saving">
      <i class="fa fa-times">close</i>
    </button>

    <!-- Read-only identity (shown in both the edit and confirm steps) -->
    <div class="read-only-field">
      <label>Business Unit</label>
      <span>{{ data.businessUnit }}</span>
    </div>
    <div class="read-only-field">
      <label>From Country</label>
      <span>{{ data.fromCountryCode }}</span>
    </div>
    <div class="read-only-field">
      <label>Component Key Value</label>
      <span>{{ data.componentKeyValue }}</span>
    </div>
    <div class="read-only-field">
      <label>Transit Time Type</label>
      <span>{{ data.transitTimeType || "N/A" }}</span>
    </div>
    <div class="type-note">
      To change the transit time type, use the <strong>Switch Transit Time Type</strong> page.
    </div>

    <hr/>

    <!-- EDIT STEP -->
    <div *ngIf="!confirming">
      <div mat-dialog-content>
        <div class="editable-field">
          <label>Mapped Services (children)</label>
          <div class="mapped-services-list" *ngIf="mappedServices.length > 0">
            <span class="mapped-service-chip" *ngFor="let service of mappedServices">
              {{ service }}
              <i class="fa fa-times" aria-hidden="true" (click)="removeMappedService(service)"></i>
            </span>
          </div>
          <div class="mapped-services-empty" *ngIf="mappedServices.length === 0">none</div>

          <label for="newMappedServiceInput" class="add-child-label">
            Add child ship method &mdash; enter the <strong>bare suffix</strong> only
            (the segment after the <code>:</code> in the Component Key Value), <strong>not</strong>
            the full prefixed value. E.g. for <code>FEDEX:FEDEX_PTP_SECOND_DAY</code> enter
            <code>FEDEX_PTP_SECOND_DAY_SAT</code>; for <code>VIRTUAL_CARRIER:SHIP_OPTION</code>
            enter the bare <code>SHIP_OPTION</code> value.
          </label>
          <div class="add-child-row">
            <input id="newMappedServiceInput" type="text" class="pure-input-2-3"
                   placeholder="e.g. FEDEX_PTP_SECOND_DAY_SAT"
                   [(ngModel)]="newMappedService" (keyup.enter)="addMappedService()"/>
            <button class="pure-button" type="button" (click)="addMappedService()">Add</button>
          </div>
          <div class="field-error" *ngIf="addError">{{ addError }}</div>
        </div>

        <!-- Placeholder for a future Ticket Details section (API is extensible) -->

        <div class="inline-error" *ngIf="inlineError">{{ inlineError }}</div>
      </div>

      <div mat-dialog-actions [align]="'end'">
        <button class="confirm-dialog-button-cancel" mat-raised-button type="button" (click)="cancel()">
          Cancel
        </button>
        <button class="confirm-dialog-button-confirm" mat-raised-button color="primary" type="button"
                (click)="save()" [disabled]="!hasChanges()">
          Save
        </button>
      </div>
    </div>

    <!-- CONFIRM STEP (inline, no stacked dialog) -->
    <div *ngIf="confirming">
      <div mat-dialog-content>
        <p>Please confirm the following change to mapped services:</p>
        <ul class="confirm-diff">
          <li class="added" *ngFor="let service of addedServices">+ {{ service }}</li>
          <li class="removed" *ngFor="let service of removedServices">&minus; {{ service }}</li>
        </ul>
        <div class="mapped-services-empty" *ngIf="mappedServices.length === 0">
          All mapped services will be cleared.
        </div>
        <div class="inline-error" *ngIf="inlineError">{{ inlineError }}</div>
      </div>

      <div mat-dialog-actions [align]="'end'">
        <button class="confirm-dialog-button-cancel" mat-raised-button type="button" (click)="back()" [disabled]="saving">
          Back
        </button>
        <button class="confirm-dialog-button-confirm" mat-raised-button color="primary" type="button"
                (click)="confirmSave()" [disabled]="saving">
          Confirm &amp; Save
        </button>
      </div>
    </div>
  </div>
</div>
<div class="overlay"></div>
